import { useCallback } from 'react';

import { useNavigate, useParams } from '@xing-com/crate-core-router';
import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { ROUTES } from '@xing-com/crate-jobs-paths';

export const useReturnToJobPage = (): (() => void) => {
  const { getSearchParameter } = useSearchParameter();
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  return useCallback(() => {
    const params = new URLSearchParams();

    const ijt = getSearchParameter('ijt');
    if (ijt) {
      params.set('ijt', ijt);
    }

    const urlParams = params.toString();
    navigate(
      `${ROUTES.jobs}/${slug}${urlParams.length > 0 ? `?${urlParams}` : ''}`,
      { replace: true }
    );
  }, [getSearchParameter, navigate, slug]);
};
